import CloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import { RemoveSubstitutionPartModalType } from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/RemoveSubstitutionPartModalType';
import { useDeleteSubstitutionPartQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteSubstitutionPartQueryOption';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const RemoveSubstitutionPartModal: React.FC<
  RemoveSubstitutionPartModalType
> = ({
  partName,
  removeModal,
  setRemoveModal,
  partId,
  completeRemove,
  type,
}) => {
  const { id, damagedId } = useParams();
  const { mutate: removeSubstitutionPart, isPending: loading } =
    useDeleteSubstitutionPartQuery({ type: type ?? 'property' });

  const removeSubstitutionPartHandler = () => {
    removeSubstitutionPart(
      {
        id: +id!,
        damaged_id: +damagedId!,
        part_id: partId!,
        source: 'pwa',
      },
      {
        onSuccess: () => {
          setRemoveModal(false);
          completeRemove && completeRemove();
        },
      },
    );
  };
  return (
    <MainModal open={removeModal} closeModal={() => setRemoveModal(false)}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={16}
        width="100%"
      >
        <CloseIcon />
        <Typography
          textStyle="b2"
          color="black-1"
          mt={7}
        >{`آیا از حذف قطعه " ${partName} " مطمئن هستید؟`}</Typography>
        <Flex justifyContent="space-between" width="100%" gap={8} mt={34}>
          <Box flex={1}>
            <Button
              fullWidth
              variant="outlined"
              color="common"
              onClick={() => setRemoveModal(false)}
            >
              انصراف
            </Button>
          </Box>
          <Box flex={1}>
            <LoadingButton
              fullWidth
              variant="contained"
              color="danger"
              loading={loading}
              onClick={() => removeSubstitutionPartHandler()}
            >
              حذف
            </LoadingButton>
          </Box>
        </Flex>
      </Box>
    </MainModal>
  );
};
export default RemoveSubstitutionPartModal;
